/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/self-closing-comp */
/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import { uniqBy } from "lodash";
import { useDispatch } from "react-redux";
import { CircularProgress, Box } from "@mui/material";
import { mathYearFromYearToYear } from "../constant";
import UpArrow from "../assets/icons/UpArrow";
import DownArrow from "../assets/icons/DownArrow";
import CustomSelect from "../../common/components/CustomSelect";
import { commonActions } from "../../common/redux/actions";
import { abbreviateNumberFormatter, fixedNumber } from "../../common/utils/constant";
import { eventTracking } from "../../../firebase/firebaseConfig";

function CustomCircularProgress({ value, size, thickness, color, sx }: any) {
  return (
    <Box sx={sx}>
      <Box sx={{ position: "relative" }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) => theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
          }}
          size={size}
          thickness={thickness}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          sx={{
            color,
            position: "absolute",
            left: 0
          }}
          value={value}
          size={size}
          thickness={thickness}
        />
      </Box>
    </Box>
  );
}

type TArrConvertListYear = () => {
  value: string;
  label: string;
}[];

function GoalLineStatistic({ data, dataUserInfos, isFirstRender, hideTitle = false, hideFilter = false }: any) {
  const goalData = data;
  const dispatch = useDispatch();
  const [month, setMonth] = React.useState<number>(moment().month() + 1);
  const lastMonth = month - 1 === 0 ? 12 : month - 1;
  const [year, setYear] = React.useState<string>(moment().format("YYYY"));

  const getGoalData = () => {
    const params = {
      last_date: moment(year).format("YYYYMMDD")
    };
    dispatch(commonActions.handleGetStatisticData(params));
  };
  const learningHour = () => {
    if (month) {
      return goalData?.goals?.find((v: any) => moment.unix(v?.time_goal).month() + 1 === month)?.done_time;
    }
    return 0;
  };

  const correctPercent = () => {
    if (
      goalData?.goals
        ?.find((item: any) => moment.unix(item?.time_goal).month() + 1 === month)
        ?.done_correct_quiz_rate?.toFixed(2)
    ) {
      return goalData?.goals
        ?.find((item: any) => moment.unix(item?.time_goal).month() + 1 === month)
        ?.done_correct_quiz_rate?.toFixed(2);
    }
    return 0;
  };
  const timeGoalsLastMonth = Number(
    goalData?.goals?.find((item) => moment.unix(item?.time_goal).month() + 1 === lastMonth)?.done_time
  );
  const timeGoalsInMonth = Number(
    goalData?.goals?.find((item) => moment.unix(item?.time_goal).month() + 1 === month)?.done_time
  );
  const targetTimeInMonth = goalData?.goals?.find(
    (item) => moment.unix(item?.time_goal).month() + 1 === month
  )?.target_time;

  const targetCorrectQuizRate = goalData?.goals?.find(
    (item: any) => moment.unix(item?.time_goal).month() === month
  )?.target_correct_quiz_rate;
  const percentSpentTimeWithLastMonth = () => {
    return timeGoalsLastMonth === timeGoalsInMonth
      ? 0
      : timeGoalsLastMonth === 0
      ? 100
      : Number((((timeGoalsInMonth - timeGoalsLastMonth) / timeGoalsLastMonth) * 100)?.toFixed(0));
  };
  const totalCorrectQuizMonthInLastMonth = goalData?.goals?.find((item) => {
    return moment.unix(item?.time_goal).month() + 1 === lastMonth;
  })?.done_correct_quiz_rate;
  const totalCorrectQuizInMonth = goalData?.goals?.find((item: any) => {
    return moment.unix(item?.time_goal).month() + 1 === month;
  })?.done_correct_quiz_rate;
  const percentCorrectQuizWithLastMonth = () => {
    return totalCorrectQuizMonthInLastMonth === totalCorrectQuizInMonth
      ? 0
      : totalCorrectQuizMonthInLastMonth === 0
      ? 100
      : Number(
          (
            ((totalCorrectQuizInMonth - totalCorrectQuizMonthInLastMonth) / totalCorrectQuizMonthInLastMonth) *
            100
          )?.toFixed(0)
        );
  };

  const listMonthOptional = goalData?.goals?.map((item) => {
    return {
      value: moment.unix(item?.time_goal)?.month(),
      label: `Tháng ${moment.unix(item?.time_goal)?.format("MM/YYYY")}`
    };
  });
  const convertListYearOptional: TArrConvertListYear = () => {
    let listYear: number[] = [];
    const yearNow: string = moment().format("YYYY");
    const yearCreatedAccountUser: string = moment.unix(dataUserInfos?.member?.created_at).format("YYYY");
    if (yearNow === yearCreatedAccountUser) {
      listYear = [...listYear, Number(yearNow)];
    } else {
      listYear = mathYearFromYearToYear(yearCreatedAccountUser);
    }
    return listYear.map((item) => {
      return { label: item.toString(), value: item.toString() };
    });
  };
  const genColorForCircleProgress = (number: number) => {
    if (number < 30) {
      return "#B00020";
    }
    if (number >= 30 && number <= 70) {
      return "#F79009";
    }
    return "#5ABC3D";
  };

  React.useEffect(() => {
    if (isFirstRender === false) {
      getGoalData();
    }
  }, [year]);
  return (
    <div
      style={{ backgroundColor: "white", borderRadius: 6, marginBottom: 16 }}
      className="flex flex-col bg-white md:py-4 sm:py-2 sm:w-full md:w-full"
    >
      {!hideTitle && (
        <span className="sm:px-2 md:px-0 md:mb-4 sm:mb-2 text-lg font-semibold">
          <FormattedMessage id="common.bottombar.statistics" />
        </span>
      )}
      {!hideFilter && (
        <div className="w-full flex justify-center items-center">
          <div className="flex items-center justify-center w-max h-10 border border-gray1 rounded-[20px] mb-4">
            <div className="border-r border-gray1">
              <CustomSelect
                className="h-[30px] border-r-0 px-2 "
                options={uniqBy(listMonthOptional?.reverse(), (e: any) => e?.value)}
                handleChange={(event) =>
                  eventTracking("select_statitistic_filter", { param: "month" }, () =>
                    setMonth(Number(event.target.value) + 1)
                  )
                }
                value={`${month - 1}`}
                classSelect="border-r-0 font-semibold py-1 bg-transparent"
              />
            </div>
            <div>
              <CustomSelect
                className="h-[30px] px-2"
                options={convertListYearOptional()?.filter((item) => item.value !== moment().format("YYYY"))}
                handleChange={(event) =>
                  eventTracking("select_statitistic_filter", { param: "year" }, () => setYear(event.target.value))
                }
                text={{
                  label: `${moment().format("YYYY")}`,
                  value: moment().format("YYYY")
                }}
                value={year}
                classSelect="border-l-0 font-semibold bg-transparent py-1"
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col gap-y-4 px-2">
        <div className="w-full flex sm2:items-center sm:flex-col sm:gap-y-4 sm2:gap-y-0 sm2:flex-row sm2:justify-between sm2:px-3 sm:px-4 border-gray rounded-[16px] border py-2 min-h-20 sm:gap-x-1 sm2:gap-x-0">
          <div className="flex flex-col gap-y-2 md:w-1/2">
            <span className="text-[15px] font-semibold">
              <FormattedMessage id="IDS_STATISTIC_PRACTICE_HOUR" />
            </span>
            {Number.isFinite(timeGoalsLastMonth) && (
              <div className="flex items-center flex-row gap-1 ">
                <div
                  className={`${
                    percentSpentTimeWithLastMonth() >= 0 ? "bg-greenQuiz" : "bg-red"
                  } rounded-[16px] min-w-[60px] min-h-[24px] px-2 py-1 flex flex-row items-center gap-1 whitespace-nowrap`}
                >
                  {percentSpentTimeWithLastMonth() >= 0 ? <UpArrow /> : <DownArrow />}
                  <span className="sm2:text-[15px] sm:text-xs text-white whitespace-nowrap">
                    {percentSpentTimeWithLastMonth() >= 0
                      ? abbreviateNumberFormatter(percentSpentTimeWithLastMonth())
                      : abbreviateNumberFormatter(Number(percentSpentTimeWithLastMonth()) * -1)}{" "}
                    %
                  </span>
                </div>
                <div className="text-gray1 text-xs whitespace-nowrap">
                  <span>
                    <FormattedMessage id="compare.to.last.month" />
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center sm2:gap-2 sm:gap-1 sm2:w-2/5 sm:w-full lg:w-max xl:w-1/3">
            <div className="rounded-full relative">
              <CustomCircularProgress color="#2F4D9C" size={52} thickness={4} value={100} />
              <CustomCircularProgress
                color={genColorForCircleProgress((learningHour() / targetTimeInMonth) * 100)}
                size={40}
                thickness={4}
                value={
                  (learningHour() / targetTimeInMonth) * 100 > 100
                    ? 100
                    : (learningHour() /
                        goalData?.goals?.find((item) => moment.unix(item?.time_goal).month() + 1 === month)
                          ?.target_time) *
                      100
                }
                sx={{
                  position: "absolute",
                  bottom: "50%",
                  right: "50%",
                  transform: "translate(50%, 50%)"
                }}
              />
              <span className="absolute top-[17px] left-0 text-center text-[10px] w-full">
                {fixedNumber(
                  goalData?.goals?.find((item) => {
                    return moment.unix(item?.time_goal).month() + 1 === Number(month);
                  })?.done_time
                )}
                H
              </span>
            </div>
            <div>
              <div className="flex items-center flex-row flex-nowrap text-xs gap-2">
                <div className="w-2 h-2 bg-[#2F4D9C] rounded-full"></div>
                <span className="whitespace-nowrap">
                  <FormattedMessage id="target" /> {targetTimeInMonth}H
                </span>
              </div>
              <div className="flex items-center flex-row flex-nowrap text-xs gap-2">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{
                    background: genColorForCircleProgress((learningHour() / targetTimeInMonth) * 100)
                  }}
                ></div>
                <span className="">
                  <FormattedMessage id="done" /> {fixedNumber(learningHour())}H
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex sm2:items-center sm:flex-col sm:gap-y-4 sm2:gap-y-0 sm2:flex-row sm2:justify-between sm2:px-3 sm:px-4 border-gray rounded-[16px] border py-2 min-h-20 sm:gap-x-1 sm2:gap-x-0">
          <div className="flex flex-col gap-y-2 md:w-1/2">
            <span className="text-[15px] font-semibold">
              <FormattedMessage id="IDS_STATISTIC_RIGHT_PERCENT" />
            </span>
            {Number.isFinite(totalCorrectQuizMonthInLastMonth) && (
              <div className="flex items-center flex-row gap-1 ">
                {" "}
                <div
                  className={`${
                    percentCorrectQuizWithLastMonth() >= 0 ? "bg-greenQuiz" : "bg-red"
                  } rounded-[16px] min-w-[60px] min-h-[24px] px-2 py-1 flex flex-row items-center gap-1`}
                >
                  {percentCorrectQuizWithLastMonth() >= 0 ? <UpArrow /> : <DownArrow />}
                  <span className="sm2:text-[15px] sm:text-xs text-white whitespace-nowrap">
                    {" "}
                    {percentCorrectQuizWithLastMonth() >= 0
                      ? abbreviateNumberFormatter(percentCorrectQuizWithLastMonth())
                      : abbreviateNumberFormatter(Number(percentCorrectQuizWithLastMonth()) * -1)}{" "}
                    %
                  </span>
                </div>
                <div className="text-gray1 text-xs whitespace-nowrap">
                  <span>
                    <FormattedMessage id="compare.to.last.month" />
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center sm2:gap-2 sm:gap-1 sm2:w-2/5 sm:w-full lg:w-max xl:w-1/3">
            <div className="rounded-full relative">
              <CustomCircularProgress color="#2F4D9C" size={52} thickness={4} value={targetCorrectQuizRate * 100} />
              <CustomCircularProgress
                color={genColorForCircleProgress((correctPercent() / targetCorrectQuizRate) * 100)}
                size={40}
                thickness={4}
                value={correctPercent() * 100}
                sx={{
                  position: "absolute",
                  bottom: "50%",
                  right: "50%",
                  transform: "translate(50%, 50%)"
                }}
              />
              <span className="absolute top-[17px] left-0 text-center text-[10px] w-full">
                {fixedNumber(correctPercent() * 100)}%
              </span>
            </div>
            <div>
              <div className="flex items-center flex-row flex-nowrap text-xs gap-2">
                <div className="w-2 h-2 bg-[#2F4D9C] rounded-full"></div>
                <span>
                  <FormattedMessage id="target" />{" "}
                  {(
                    goalData?.goals?.find((item: any) => moment.unix(item?.time_goal).month() + 1 === month)
                      ?.target_correct_quiz_rate * 100
                  )?.toFixed(0)}
                  %
                </span>
              </div>
              <div className="flex items-center flex-row flex-nowrap text-xs gap-2">
                <div
                  className="w-2 h-2 rounded-full"
                  style={{
                    background: genColorForCircleProgress((correctPercent() / targetCorrectQuizRate) * 100)
                  }}
                ></div>
                <span className="">
                  <FormattedMessage id="done" /> {fixedNumber(correctPercent() * 100)}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoalLineStatistic;
